export default __webpack_public_path__ + "static/84(1)-948a99715885c09f4134d2e22f43951b.png";